module.exports = __webpack_public_path__ + "static/media/Ueberuns2.06919012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Ueberuns2.jpg
// module id = 391
// module chunks = 0